<template>
  <div v-if="visible" class="alert__wrapper position-relative d-flex">
    <slot></slot>
    <CrossIcon
      v-if="props.hideable"
      :color="crossIconHovered ? '#6434D0' : '#475467'"
      class="pointer cross-icon position-absolute"
      @click="visible = false"
      @mouseover="crossIconHovered = true"
      @mouseleave="crossIconHovered = false"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import CrossIcon from "@/components/icons/cross-icon.vue";

const props = defineProps({
  hideable: {
    type: Boolean,
    default: true,
  },
  // used for storing the value in localStorage
  name: {
    type: String,
    default: null,
  },
  borderColor: {
    type: String,
    default: "#6434D0",
  },
  backgroundColor: {
    type: String,
    default: "#FFFFFF",
  },
  forceVisible: {
    type: Boolean,
    default: false,
  },
});

const visible = ref(false);
const crossIconHovered = ref(false);

// Load alert state from localStorage when the component mounts
onMounted(() => {
  const savedAlertState = localStorage.getItem(props.name);
  if (savedAlertState !== null && !props.forceVisible) {
    visible.value = JSON.parse(savedAlertState);
  } else {
    visible.value = true;
  }
});

watch(visible, (newValue) => {
  if (!props.name) return;

  localStorage.setItem(props.name, JSON.stringify(newValue));
});
</script>

<style scoped>
.alert__wrapper {
  padding: var(--spacing-3) var(--spacing-10) var(--spacing-3) var(--spacing-3);
  color: var(--color-secondary-text);
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  border: 1px solid v-bind(borderColor);
  border-left-width: 4px;
  border-radius: 4px;
  margin-bottom: var(--spacing-3);
  gap: var(--spacing-2);
  background-color: v-bind(backgroundColor);
}

.cross-icon {
  width: 24px;
  height: 24px;
  top: var(--spacing-2);
  right: var(--spacing-1);
}
</style>
